(function () {
    'use strict';

    angular
        .module('core.directives')
        .directive('telephoneField', TelephoneField);

    /** @ngInject */
    function TelephoneField($filter, LoadingHelper, UtilHelper, PhoneTypeService, PATHS) {
        function TelephoneFieldController($scope) {
            const vm = this;

            vm.getNumber = num => {
                return new Array(num);
            }

            vm.addPhone = () => {
                vm.amountOfPhones++;
            }

            vm.removePhone = index => {
                vm.telephones.splice(index, 1);

                vm.amountOfPhones--;
            }

            vm.getPhoneTypes = () => {
                LoadingHelper.startLoading('.phone-container', true);

                return PhoneTypeService
                    .getAll()
                    .then(success => {
                        vm.phoneTypes = success;
                        LoadingHelper.stopLoading('.phone-container');
                    }, error => {
                        UtilHelper.errorCallback(error);
                        LoadingHelper.stopLoading('.phone-container');
                    });
            }

            vm.handleConfigurePhones = phones => {
                vm.amountOfPhones = 1;
                let editableTelephones = angular.copy(phones);

                if (editableTelephones && editableTelephones.length) {
                    vm.amountOfPhones = editableTelephones.length;

                    editableTelephones
                        .map(telephone => {
                            telephone.PhoneComplete = $filter('formatPhoneComplete')(telephone.AreaCode + telephone.PhoneNumber);
                        });
                } else
                    editableTelephones = [];

                if (vm.editableTelephones == 0)
                    vm.editableTelephones = 1;

                vm.editableTelephones = editableTelephones;
            }

            const removeWatchField = $scope.$watch('vm.editableTelephones', (newTelephones, oldTelephones) => {
                if (angular.equals(oldTelephones, newTelephones)) return;

                let localEditedTelephones = angular.copy(newTelephones);

                for (let index = 0; index < localEditedTelephones.length; index++) {
                    const telephone = localEditedTelephones[index];

                    if (!telephone.PhoneComplete) continue;

                    const phoneClean = telephone.PhoneComplete.replace(/\D/g, '');

                    telephone.AreaCode = phoneClean.slice(0, 2);
                    telephone.PhoneNumber = phoneClean.slice(2);

                    delete telephone.PhoneComplete;
                }

                vm.telephones = angular.copy(localEditedTelephones);
            }, true);

            $scope.$on('$destroy', () => {
                removeWatchField();
            });

            init();

            function init() {
                vm.editableTelephones = [];
                vm.phoneTypes = [];
            }
        }

        function link(scope, element, attrs, ctrl) {
            ctrl.getPhoneTypes()
                .then(() => ctrl.handleConfigurePhones(ctrl.telephones));

            let removeWatchPhones = scope.$watch(() => {
                return ctrl.telephones;
            }, (newTelephones, oldTelephones) => {
                if (angular.equals(oldTelephones, newTelephones)) return;

                ctrl.handleConfigurePhones(newTelephones);
            });

            scope.$on('$destroy', () => {
                removeWatchPhones();
            });
        }

        return {
            bindToController: true,
            controller: TelephoneFieldController,
            controllerAs: 'vm',
            restrict: 'AE',
            link: link,
            templateUrl: `${PATHS.PHYSICAL}/directives/telephone-field/telephone-field.html`,
            scope: {
                telephones: '=',
                canEdit: '=',
                showType: '='
            },
        }
    }
}());